import React from 'react';
import { Outlet } from 'react-router-dom';
import NavigationBar from './NavigationBar';
import Footer from './Footer';

const UserLayout = () => {
  return (
    <div className="user-layout">
      <NavigationBar />
      <main className="user-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default UserLayout;